import { Navbar, Nav, NavDropdown, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useEffect } from "react";
import { useAppSelector } from "../../app/hooks";
import { userManager } from "../auth/authService";
import { getWalletAsync } from "../payments/paymentsSlice";
import { useDispatch } from "react-redux";
import WalletNav from "./WalletNav";
import { FaUserAlt } from "react-icons/fa";

export function MainNav() {
  var dispatch = useDispatch();

  var auth = useAppSelector((state) => state.auth);
  // var wallet = useAppSelector((state) => state.payments.wallet);

  useEffect(() => {
    if (auth.user !== null) {
      dispatch(getWalletAsync(auth.user.profile.sub));
    }
  }, [auth.user]);

  return (
    <Navbar bg={"dark"} variant="dark" className="p-4">
      <Navbar.Brand href="/">WannaBet</Navbar.Brand>
      <Navbar.Collapse>
        <Nav>
          <Link to={"/wagers"} className="nav-link">
            Wagers
          </Link>
        </Nav>
      </Navbar.Collapse>

      <Navbar.Collapse className="justify-content-end">
        <Nav>
          {auth.user === null ? (
            <>
              <Link to={"/login"} className="mx-1">
                <Button>Login</Button>
              </Link>

              <Link to={"/register"} className="mx-1">
                <Button>Register</Button>
              </Link>
            </>
          ) : (
            <>
              <NavDropdown align="end" title="balances">
                <WalletNav />
              </NavDropdown>
              <NavDropdown align="end" title={<FaUserAlt />}>
                <NavDropdown.Item href="">Edit Account</NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item onClick={() => {
                  userManager.signoutRedirect();
                }}>
                  Logout
                </NavDropdown.Item>
              </NavDropdown>
            </>
          )}
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
}

export default MainNav;
